import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InformaisComponent } from "./informais.component";
import { CadastroInformaisComponent } from "./cadastro.component";

@NgModule({
  declarations: [
    InformaisComponent,
    CadastroInformaisComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    InformaisComponent
  ]
})

export class InformaisModule {}
